import { isDevelopmentEnv, isStagingEnv } from '@mc/client-env'
import { logger } from '@mc/next-logger'
import { isQuotaExceededError } from '../utils'

/**
 * Sets a localStorage item safely by checking availability and catching errors.
 *
 * @param {string} key - The key to set in localStorage.
 * @param {string} value - The value to store.
 */
export const safeSetLocalStorageItem = (key: string, value: string): void => {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined')
    return

  try {
    localStorage.setItem(key, value)
  } catch (err) {
    if (isDevelopmentEnv() || isStagingEnv()) {
      // This check added because third-party SDKs like Amplitude batch unsent events into `localStorage` under keys
      // like amplitude_unsent_*. Those blobs can swell to several megabytes if events aren’t flushed promptly, pushing
      // you over the ~5 MB quota and causing every subsequent `setItem` call to fail.
      if (isQuotaExceededError(err)) {
        logger.error(
          `Quota Exceeded (localStorage full) writing to key ["${key}"]`,
          err,
        )
      } else {
        logger.error(`Error setting localStorage key "${key}":`, err)
      }
    }
  }
}
